const l = {
  name: "PayByLinkPlane",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,0l-6.8,24l-4.9-12.2L0,6.8L24,0z M6.1,7.2l6.6,2.7l6.3-6.4L6.1,7.2z M16.8,17.8l3.7-12.9l-6.3,6.4
			L16.8,17.8z"/>
		<path class="st0" d="M1.7,23.7l8-8l-1.4-1.4l-8,8L1.7,23.7z"/>
		<path class="st0" d="M5.7,12.7l-4,4l-1.4-1.4l4-4L5.7,12.7z"/>
		<path class="st0" d="M8.7,23.7l4-4l-1.4-1.4l-4,4L8.7,23.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as PayByLinkPlane
};
